import { render, staticRenderFns } from "./PurchaseOrderCreate.vue?vue&type=template&id=28a2b8bf&"
import script from "./PurchaseOrderCreate.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports